import { Injectable, signal } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ThemeService {
  private readonly _STORAGE_KEY = "theme";
  public isLightThemeSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public isLightTheme$ = this.isLightThemeSubject.asObservable();

  constructor() {
    this._loadInitialTheme();

    this.isLightThemeSubject.subscribe((value) => {
      this.isLightThemeSignal.set(value);
    });
  }

  private _loadInitialTheme() {
    const savedTheme: string | null = localStorage.getItem(this._STORAGE_KEY);
    const isLight: boolean = savedTheme !== "dark";

    document.body.classList.toggle("light", isLight);
    this.isLightThemeSubject.next(isLight);
  }

  public toggleTheme() {
    const isLight: boolean = document.body.classList.toggle("light");

    if (isLight) {
      localStorage.setItem(this._STORAGE_KEY, "light");
      this.isLightThemeSubject.next(true);
    } else {
      localStorage.setItem(this._STORAGE_KEY, "dark");
      this.isLightThemeSubject.next(false);
    }
  }

  public isLightThemeSignal = signal(this.isLightThemeSubject.value);

  public isLightTheme(): boolean {
    return document.body.classList.contains("light");
  }
}
